"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
function RestrictionsIcon(props) {
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M12.0003,2.0001 C17.5233,2.0001 22.0003,6.4771 22.0003,12.0001 C22.0003,17.5221 17.5233,22.0001 12.0003,22.0001 C6.4773,22.0001 2.0003,17.5221 2.0003,12.0001 C2.0003,6.4771 6.4773,2.0001 12.0003,2.0001 Z M6.7533,17.2461 C9.3913,19.8841 13.4243,20.0701 16.2553,18.0801 L5.9203,7.7451 C3.9313,10.5731 4.1143,14.6071 6.7533,17.2461 Z M17.2463,6.7541 C14.6083,4.1161 10.5753,3.9301 7.7443,5.9201 L18.0803,16.2551 C20.0683,13.4271 19.8853,9.3921 17.2463,6.7541 Z" })));
}
exports.default = RestrictionsIcon;
